import { Delete, Edit } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import DetailsMasterPageContext from "../../../../context/DetailsMasterPageContext/DetailsMasterPageContext";
import {
  Delete_Details_Master_Page,
  Enable_Disable_Details_Master_Page,
  Get_Details_Details_Master_Page,
} from "../../../../Apis/detailsMasterPageApi/DetailsMasterPageApi";

const DetailsMasterPageDataTabelContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setdialogs,
    setId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(DetailsMasterPageContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get details page master Details
   */
  const {
    mutate: detailsPageMasterDetails,
    isLoading: isLoadingDetailsMasterPage,
  } = useMutation((detailsMasterId) =>
    Get_Details_Details_Master_Page(detailsMasterId, setFormData, setdialogs)
  );

  const GetDetailsMasterPageDetails = (detailsMasterId) => {
    detailsPageMasterDetails(detailsMasterId);
    setId(detailsMasterId);
    setIsEdit(false);
  };

  /**
   * delete details master page
   */
  const { mutate: detailsMasterPageDelete, isLoading: isLoadingDelete } =
    useMutation((detailsMasterId) =>
      Delete_Details_Master_Page(detailsMasterId, refetch)
    );

  const DeleteDetailsMasterPage = async (detailsMasterId) => {
    let { isConfirmed } = await SweetConfirmation();
    if (isConfirmed) {
      detailsMasterPageDelete(detailsMasterId);
    }
  };

  /**
   * enable / disable details master page
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    Enable_Disable_Details_Master_Page(formData, refetch)
  );

  const handleDetailsMasterPageStatusChange = (detailsMasterId, status) => {
    let formDate = {
      detailsMasterId: detailsMasterId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.detailsMasterId === detailsMasterId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 250,
      field: "title",
      headerName: "Title",
      renderCell: (params) => (params.row.title ? params.row.title : "--"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleDetailsMasterPageStatusChange(
                params.row.detailsMasterId,
                params.row.isActive
              )
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Edit">
              <IconButton
                aria-label="edit"
                onClick={() =>
                  GetDetailsMasterPageDetails(params.row.detailsMasterId)
                }
              >
                <Edit style={{ color: "#7366ff" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() =>
                  DeleteDetailsMasterPage(params.row.detailsMasterId)
                }
              >
                <Delete style={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse
        isLoading={isLoadingDetailsMasterPage || isLoadingDelete}
      />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.detailsMasterId}
        addButton={true}
      />
    </Fragment>
  );
};

export default DetailsMasterPageDataTabelContainer;
